import { createContext, useState } from "react"

const ContextualSidebarContext = createContext()

const ContextualSidebarContextProvider = ({ children }) => {
  const [contextualSidebar, setContextualSidebar] = useState({
    title: null,
    subTitle: null,
    content: null,
    open: false,
    size: "lg",
    onClose: null,
  })

const setOpen = (isOpen) => {
    // 1. Always update the open state immediately
    setContextualSidebar(prev => ({ ...prev, open: isOpen }))

    // 2. If we are closing (!isOpen) AND a custom onClose exists, run it
    if (!isOpen && typeof contextualSidebar.onClose === 'function') {
      contextualSidebar.onClose();
    }
  }

  return (
    <ContextualSidebarContext.Provider
      value={{ contextualSidebar, setContextualSidebar, open: contextualSidebar.open, setOpen }}
    >
      {children}
    </ContextualSidebarContext.Provider>
  )
}

export { ContextualSidebarContext, ContextualSidebarContextProvider }
